import { Navigate, createBrowserRouter } from "react-router-dom";

/**ADMIN ROUTE START */
import AdminLayout from "./modules/admin/shared/adminlayout";
import Login from "./modules/admin/pages/login";
import PrivateRoute from "./modules/admin/shared/privateRoute";
import PublicRoute from "./modules/admin/shared/publicRoute";
import Profile from "./modules/admin/pages/profile";
import EditProfile from "./modules/admin/pages/editprofile";
import Changepassword from "./modules/admin/pages/changepassword";
import OtpVerificationPage from "./modules/admin/pages/otpverification";
import ForgotPwdPage from "./modules/admin/pages/forgotpassword";
import ResetPwdPage from "./modules/admin/pages/resetpwd";
import Error404 from "./modules/admin/pages/404";
import Dashboard from "./modules/admin/pages/dashboard";
import EmailTemplatesTable from "./modules/admin/pages/cms/automaticemailtemplates/list";
import EmailTempAdd from "./modules/admin/pages/cms/automaticemailtemplates/add";
import EmailTempEdit from "./modules/admin/pages/cms/automaticemailtemplates/edit";
import ViewEmailTemp from "./modules/admin/pages/cms/automaticemailtemplates/view";
import PageTable from "./modules/admin/pages/cms/pages/list";
import PageAdd from "./modules/admin/pages/cms/pages/add";
import PageEdit from "./modules/admin/pages/cms/pages/edit";
import PageView from "./modules/admin/pages/cms/pages/view";
import GlobalSettings from "./modules/admin/pages/cms/settings/settings";

import CompleteAdminProfile from "./modules/admin/pages/completeAdminProfile";

import InvoiceDesign from "./modules/admin/pages/invoiceDesign";
import AdminUnAuthLayout from "./modules/admin/shared/adminUnAuthLayout";
import FAQAdd from "./modules/admin/pages/cms/faq/add";
import FAQEdit from "./modules/admin/pages/cms/faq/edit";
import FAQTable from "./modules/admin/pages/cms/faq/list";
import FAQView from "./modules/admin/pages/cms/faq/view";
import ContactUsTable from "./modules/admin/pages/contactUs/list";
import ViewContactUs from "./modules/admin/pages/contactUs/view";
import UserTable from "./modules/admin/pages/user/list";
import UserView from "./modules/admin/pages/user/view";
import UserEdit from "./modules/admin/pages/user/edit";
import SubscriptionPlanTable from "./modules/admin/pages/subscriptionPlan/list";
import AddSubscriptionPlan from "./modules/admin/pages/subscriptionPlan/add";
import EditSubscriptionPlan from "./modules/admin/pages/subscriptionPlan/edit";
import SubscriptionPlanView from "./modules/admin/pages/subscriptionPlan/view";
import PayableTransactionTable from "./modules/admin/pages/payableTransaction/list";
import PayoutTransactionTable from "./modules/admin/pages/payoutTransaction/list";
import TransactionTable from "./modules/admin/pages/transaction/list";
import UserAdd from "./modules/admin/pages/user/add";
import WebsiteHome from "./modules/website/pages/webHome";
import Page404 from "./modules/website/common/Page404";
import GameTable from "./modules/admin/pages/game/list";
import GameAdd from "./modules/admin/pages/game/add";
import GameEdit from "./modules/admin/pages/game/edit";
import GameView from "./modules/admin/pages/game/view";
import RewardConfigTable from "./modules/admin/pages/reward-config/list";
import RewardConfigAdd from "./modules/admin/pages/reward-config/add";
import RewardConfigEdit from "./modules/admin/pages/reward-config/edit";
import RewardConfigView from "./modules/admin/pages/reward-config/view";
import AnalyticsView from "./modules/admin/pages/analytics/view";
import NotificationTable from "./modules/admin/pages/notification/list";
import CMSPage from "./modules/website/pages/CMSPage";
import ContactUs from "./modules/website/pages/ContactUs";
import PaymentTransactionList from "./modules/admin/pages/payment-transaction/list";
import FailedTransactions from "./modules/admin/pages/payment-transaction/failed-transactions";
import ManualRecovery from "./modules/admin/pages/payment-transaction/manual-recovery";

const router = createBrowserRouter([
  /** user auth end */

  // { path: "/inquiry", element: <Enquire /> },

  {
    path: "/",
    element: <WebsiteHome />,
  },
  {
    path: "/page/:slug",
    element: <CMSPage />,
  },
  {
    path: "/terms-and-conditions",
    element: <CMSPage fixedSlug="terms-and-conditions" />,
  },
  {
    path: "/privacy-policy",
    element: <CMSPage fixedSlug="user-privacy-policy" />,
  },
  {
    path: "/delete-account",
    element: <CMSPage fixedSlug="delete-account" />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  { path: "*", element: <Page404 /> },

  /**ADMIN ROUTE START */
  {
    path: "admin",
    element: <PrivateRoute component={AdminLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/admin/dashboard"} />,
      },
      {
        path: "dashboard",
        element: <PrivateRoute component={Dashboard} />,
      },
      {
        path: "analysis",
        element: <PrivateRoute component={AnalyticsView} />,
      },
      {
        path: "invoice-design",
        element: <PrivateRoute component={InvoiceDesign} />,
      },
      {
        path: "profile",
        // element: <Profile />,
        element: <PrivateRoute component={Profile} />,
        children: [
          {
            path: "edit/:id",
            // element: <EditProfile />,
            element: <PrivateRoute component={EditProfile} />,
          },
          {
            path: "change-password/:id",
            // element: <Changepassword />,
            element: <PrivateRoute component={Changepassword} />,
          },
        ],
      },

      {
        /**  User management route start */
      },
      {
        path: "user-management/user/list/:pgno",
        element: <UserTable />,
      },
      {
        path: "user-management/user/view/:id",
        element: <UserView />,
      },
      {
        path: "user-management/user/:pgno/edit/:id",
        element: <UserEdit />,
      },
      {
        path: "user-management/user/add",
        element: <UserAdd />,
      },
      {
        /** User management route end */
      },

      {
        /** Game management route start */
      },
      {
        path: "game-management/game/list/:pgno",
        element: <GameTable />,
      },
      {
        path: "game-management/game/view/:id",
        element: <GameView />,
      },
      {
        path: "game-management/game/add",
        element: <GameAdd />,
      },
      {
        path: "game-management/game/:pgno/edit/:id",
        element: <GameEdit />,
      },
      {
        /** Game management route end */
      },

      {
        /** Reward management route start */
      },
      {
        path: "reward-management/reward-config/list/:pgno",
        element: <RewardConfigTable />,
      },
      {
        path: "reward-management/reward-config/view/:id",
        element: <RewardConfigView />,
      },
      {
        path: "reward-management/reward-config/add",
        element: <RewardConfigAdd />,
      },
      {
        path: "reward-management/reward-config/:pgno/edit/:id",
        element: <RewardConfigEdit />,
      },
      {
        /** Reward management route end */
      },

      {
        /**contact-us route start */
      },
      {
        path: "contact-us/list/:pgno",
        element: <PrivateRoute component={ContactUsTable} />,
      },
      {
        path: "contact-us/view/:id",
        element: <PrivateRoute component={ViewContactUs} />,
      },
      {
        /**contact-us route end */
      },

      {
        path: "notification/list/:pgno",
        element: <PrivateRoute component={NotificationTable} />,
      },

      /* transaction start */
      {
        path: "payable-transaction/list/:pgno",
        element: <PrivateRoute component={PayableTransactionTable} />,
      },
      {
        path: "payout-transaction/list/:pgno",
        element: <PrivateRoute component={PayoutTransactionTable} />,
      },
      {
        path: "subscription/transaction/list/:pgno",
        element: <PrivateRoute component={TransactionTable} />,
      },
      {
        path: "subscription/payment-transactions/list/:pgno",
        element: <PrivateRoute component={PaymentTransactionList} />,
      },
      {
        path: "subscription/failed-transactions/list/:pgno",
        element: <PrivateRoute component={FailedTransactions} />,
      },
      {
        path: "subscription/manual-recovery",
        element: <PrivateRoute component={ManualRecovery} />,
      },
      /* transaction end */

      {
        path: "cms/pages/list/:pgno",
        element: <PrivateRoute component={PageTable} />,
      },
      {
        path: "cms/pages/add",
        element: <PrivateRoute component={PageAdd} />,
      },
      {
        path: "cms/pages/:pgno/edit/:id",
        element: <PrivateRoute component={PageEdit} />,
      },
      {
        path: "cms/pages/view/:id",
        element: <PrivateRoute component={PageView} />,
      },

      // FAQ

      {
        path: "cms/faq/list/:pgno",
        element: <PrivateRoute component={FAQTable} />,
      },
      {
        path: "cms/faq/add",
        element: <PrivateRoute component={FAQAdd} />,
      },
      {
        path: "cms/faq/:pgno/edit/:id",
        element: <PrivateRoute component={FAQEdit} />,
      },
      {
        path: "cms/faq/view/:id",
        element: <PrivateRoute component={FAQView} />,
      },

      {
        path: "cms/settings",
        element: <PrivateRoute component={GlobalSettings} />,
      },

      {
        path: "cms/default-email-template/list/:pgno",
        element: <PrivateRoute component={EmailTemplatesTable} />,
      },
      {
        path: "cms/default-email-template/add",
        element: <PrivateRoute component={EmailTempAdd} />,
      },
      {
        path: "cms/default-email-template/:pgno/edit/:id",
        element: <PrivateRoute component={EmailTempEdit} />,
      },
      {
        path: "cms/default-email-template/view/:id",
        element: <PrivateRoute component={ViewEmailTemp} />,
      },

      /** Email Logs Routing End*/


      // plan
      {
        path: "subscription/subscription-plan/list/:pgno",
        element: <PrivateRoute component={SubscriptionPlanTable} />,
      },
      {
        path: "subscription/subscription-plan/add",
        element: <PrivateRoute component={AddSubscriptionPlan} />,
      },
      {
        path: "subscription/subscription-plan/edit/:id",
        element: <PrivateRoute component={EditSubscriptionPlan} />,
      },
      {
        path: "subscription/subscription-plan/view/:id",
        element: <PrivateRoute component={SubscriptionPlanView} />,
      },
    ],
  },
  {
    path: "admin",
    element: <AdminUnAuthLayout />,
    children: [
      { path: "login", element: <PublicRoute component={Login} /> },
      {
        path: "forget-password",
        element: <PublicRoute component={ForgotPwdPage} />,
      },
      {
        path: "otp-verification/:email",
        element: <PublicRoute component={OtpVerificationPage} />,
      },
      {
        path: "reset-password",
        // element: localStorage.getItem("validate_string") ? <PrivateRoute component={ResetPwdPage} /> : <Navigate to="/admin/login" />
        element: <PublicRoute component={ResetPwdPage} />,
      },
    ],
  },
  {
    path: "admin/complete-profile/:validate_string",
    element: <PublicRoute component={CompleteAdminProfile} />,
  },

  { path: "admin/*", element: <Error404 /> },
]);

export default router;
